import { combineEpics } from 'redux-observable';

import { createOrganizerEpic }                from './CreateOrganizer/CreateOrganizerEpic';
import { deleteOrganizerEpic }                from './DeleteOrganizer/DeleteOrganizerEpic';
import { findOrganizersEpic }                 from './FindOrganizers/FindOrganizersEpic';
import { searchOrganizersEpic }               from './SearchOrganizers/SearchOrganizersEpic';
import { findOrganizerEpic }                  from './FindOrganizer/FindOrganizerEpic';
import { updateOrganizerEpic }                from './UpdateOrganizer/UpdateOrganizerEpic';
import { removeEmployeeFromOrganisationEpic } from './RemoveEmployeeFromOrganisation/RemoveEmployeeFromOrganisationEpic';


export const organizerEpics = combineEpics(
  createOrganizerEpic,
  deleteOrganizerEpic,
  findOrganizersEpic,
  searchOrganizersEpic,
  findOrganizerEpic,
  updateOrganizerEpic,
  removeEmployeeFromOrganisationEpic,
);
